import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import { Table, Th, Td } from 'components/Table';
import PlayerLink from 'components/PlayerLink';
import { dp } from 'components/util';

export default class BowlingSeasonsPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { averages, limit, sort, sortColumn } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="bowling-seasons-page">
                    <Panel border>
                        <PanelTop title={`Top ${limit} Bowling Seasons`} buttons />
                        <BowlingSeasonsTable averages={averages} sort={sort} sortColumn={sortColumn} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const BowlingSeasonsTable = ({ averages, sort, sortColumn }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th min="8" />
                <Th left>Name</Th>
                <Th>Season</Th>
                <Th sortable min="2" short="3" value="O" id="overs" sort={sort} onSort={sortColumn}>
                    Overs
                </Th>
                <Th sortable priority="2" short="3" value="M" id="maidens" sort={sort} onSort={sortColumn}>
                    Maidens
                </Th>
                <Th sortable priority="2" short="3" value="R" id="runs" sort={sort} onSort={sortColumn}>
                    Runs
                </Th>
                <Th sortable min="2" short="3" value="W" id="wickets" sort={sort} onSort={sortColumn}>
                    Wickets
                </Th>
                <Th sortable min="2" short="3" value="Avg" id="average" sort={sort} onSort={sortColumn}>
                    Average
                </Th>
                <Th sortable priority="2" short="4" value="S/R" id="strike" sort={sort} onSort={sortColumn}>
                    Strike Rate
                </Th>
                <Th sortable priority="2" short="4" value="E/R" id="economy" sort={sort} onSort={sortColumn}>
                    Economy Rate
                </Th>
                <Th sortable priority="2" short="4" value="Best" id="best" sort={sort} onSort={sortColumn}>
                    Best Figures
                </Th>
            </tr>
        </thead>
        <tbody>{averages.map((row, index) => <BowlingSeasonsRow key={`${row.pid}/${row.season}`} index={index} row={row} />)}</tbody>
    </Table>
);

const BowlingSeasonsRow = ({ row, index }) => (
    <tr>
        <Td min="8">{index + 1}</Td>
        <Td left>
            <PlayerLink pid={row.pid} fname={row.fname} lname={row.lname} />
        </Td>
        <Td>{row.season}</Td>
        <Td sortable min="2">
            {row.overs}
        </Td>
        <Td sortable priority="2">
            {row.maidens}
        </Td>
        <Td sortable priority="2">
            {row.runs}
        </Td>
        <Td sortable min="2">
            {row.wickets}
        </Td>
        <Td sortable min="2">
            {dp(row.average)}
        </Td>
        <Td sortable priority="2">
            {dp(row.strike)}
        </Td>
        <Td sortable priority="2">
            {dp(row.economy)}
        </Td>
        <Td sortable priority="2" short="3" value={`${row.best_wickets}/${row.best_runs}`}>
            {row.best_wickets} for {row.best_runs}
        </Td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/views/bowling-seasons/BowlingSeasonsPage.jsx